import {
  WAIT_PAGINATED_RESPONSE,
  CLEAR_PAGINATED_RESPONSE,
  LOGOUT_COMPLETE,
  FILE_REINGESTION_SUCCESS,
  GET_RESOURCE_FILES_SUCCESS,
  GET_RESOURCE_QUARANTINE_FILES_SUCCESS,
  GET_RESOURCE_QUARANTINE_SAMPLES_SUCCESS,
  GET_RESOURCE_CRON_HISTORY_SUCCESS,
  GET_RESOURCE_NOTIFICATIONS_SUCCESS,
  UPDATE_RESOURCE_NOTIFICATION_AS_READ_SUCCESS,
  DELETE_RESOURCE_NOTIFICATION_SUCCESS,
} from '../../constants/actionTypes';

import { FILE_LIST_SORT_CRITERIA } from '../../constants/paginationConstants';
import { RESOURCE_TYPE_SINK } from 'js/constants/resourceTypes';
// import { FILES_PAGINATED } from '../../constants/paginationEntitiesTypes';
import Constants from '../../Constants';
import moment from 'moment';

import {
  has,
  values,
  isArray,
  orderBy,
  find,
  isNil,
  map,
  includes,
  ceil,
  each,
  pull,
} from 'lodash';

const initialState = {
  relatedTypes: [],
  data: {},
};

const noId = 'ALL';

export const paginationReducer = (state = initialState, action) => {
  switch (action.type) {
    case WAIT_PAGINATED_RESPONSE:
      return setRelatedType(state, action);
    case CLEAR_PAGINATED_RESPONSE:
      return clearRelatedData(state, action);
    case LOGOUT_COMPLETE:
      return initialState;

    case FILE_REINGESTION_SUCCESS:
    case UPDATE_RESOURCE_NOTIFICATION_AS_READ_SUCCESS:
      return updateRelatedData(state, action);

    case DELETE_RESOURCE_NOTIFICATION_SUCCESS:
      return removeRelatedDataItem(state, action);

    default:
      if (state.relatedTypes.indexOf(action.type) > -1) {
        return setRelatedData(state, action);
      } else {
        return state;
      }
  }
};

function setRelatedType(state, action) {
  if (state.relatedTypes.indexOf(action.relatedType) === -1) {
    return {
      ...state,
      relatedTypes: [...state.relatedTypes, action.relatedType],
    };
  } else {
    return state;
  }
}

function setRelatedData(state, action) {
  let { requestInfo, result, type, rspHeaders } = action;
  let id = requestInfo.id || noId;
  let data = { ...state.data };
  if (!data[requestInfo.paginatedResource]) {
    data[requestInfo.paginatedResource] = {};
  }
  if (!data[requestInfo.paginatedResource][requestInfo.resourceType]) {
    data[requestInfo.paginatedResource][requestInfo.resourceType] = {};
  }

  switch (type) {
    case GET_RESOURCE_FILES_SUCCESS:
    case GET_RESOURCE_QUARANTINE_FILES_SUCCESS:
    case GET_RESOURCE_CRON_HISTORY_SUCCESS:
      if (has(result, 'metrics.data')) {
        if (!isArray(result.metrics.data)) {
          let sortKey = null,
            sortOrder = null;

          if (has(requestInfo, 'orderby')) {
            let sortByItem = find(FILE_LIST_SORT_CRITERIA, (s) => {
              return s.value === requestInfo.orderby;
            });

            if (!isNil(sortByItem)) {
              sortKey = sortByItem.sortKey;
              sortOrder = sortByItem.sortOrder;
            }
          }

          if (!sortKey && requestInfo.defaultSortKey) {
            //find if it is read or write data
            sortKey = requestInfo.defaultSortKey;
            sortOrder = 'desc';
          }

          let sortedData = sortKey
            ? orderBy(result.metrics.data, [sortKey], [sortOrder])
            : values(result.metrics.data);

          if (type === GET_RESOURCE_CRON_HISTORY_SUCCESS) {
            sortedData = map(sortedData, (sd) => {
              const { runId, lastWritten, lastModified } = sd;
              const time =
                requestInfo.resourceType === RESOURCE_TYPE_SINK
                  ? lastWritten || runId
                  : runId || lastWritten;
              const runIdTime = time ? moment(time).toISOString() : lastModified;
              return { ...sd, runIdTime };
            });
          }

          let metrics = {
            ...result.metrics,
            data:
              requestInfo.aggregate && requestInfo.page !== 1
                ? [...currentData?.metrics?.data, ...sortedData]
                : sortedData,
            meta: {
              ...result.metrics.meta,
              orderBy: requestInfo.orderby,
              status: requestInfo.status,
            },
          };

          data[requestInfo.paginatedResource][requestInfo.resourceType][id] = {
            ...result,
            metrics,
          };
        } else {
          let sortedData = result.metrics.data;

          if (type === GET_RESOURCE_CRON_HISTORY_SUCCESS) {
            sortedData = map(sortedData, (sd) => {
              const { runId, lastWritten, lastModified } = sd;
              const time =
                requestInfo.resourceType === RESOURCE_TYPE_SINK
                  ? lastWritten || runId
                  : runId || lastWritten;
              const runIdTime = time ? moment(time).toISOString() : lastModified;
              return { ...sd, runIdTime };
            });
          }
          const currentData = data[requestInfo.paginatedResource][requestInfo.resourceType][id];

          let metrics = {
            ...result.metrics,
            data:
              requestInfo.aggregate && requestInfo.page !== 1
                ? [...currentData?.metrics?.data, ...sortedData]
                : sortedData,
            meta: {
              ...result.metrics.meta,
              orderBy: requestInfo.orderby,
              status: requestInfo.status,
            },
          };
          data[requestInfo.paginatedResource][requestInfo.resourceType][id] = {
            ...result,
            metrics,
          };
        }
      } else {
        data[requestInfo.paginatedResource][requestInfo.resourceType][id] = result;
      }

      break;

    case GET_RESOURCE_QUARANTINE_SAMPLES_SUCCESS:
      if (has(result, 'output.data')) {
        let sortedData = map(result.output.data, (sd) => {
          const { time } = sd;
          let errorObj = has(sd, 'error') ? sd.error : null;

          const errorTime = !isNil(time) ? moment(time).toISOString() : null;
          return { ...sd, error: errorObj, errorTime };
        });

        let output = { ...result.output, data: sortedData };
        data[requestInfo.paginatedResource][requestInfo.resourceType][id] = {
          ...result,
          output,
        };
      } else {
        data[requestInfo.paginatedResource][requestInfo.resourceType][id] = result;
      }
      break;

    case GET_RESOURCE_NOTIFICATIONS_SUCCESS:
    default:
      const meta = getPaginationMetaFromResponseHeaders(rspHeaders, requestInfo);

      let ids = [],
        items = {};
      each(result, (r) => {
        items[r.id] = r;
        ids.push(r.id);
      });

      const currentData =
        data[requestInfo.paginatedResource][requestInfo.resourceType][id]?.data || {};

      data[requestInfo.paginatedResource][requestInfo.resourceType][id] = {
        data: requestInfo.aggregate
          ? {
              items: {
                ...currentData?.items,
                ...items,
              },
              ids: [...currentData?.ids, ...ids],
            }
          : { items, ids },
        meta,
      };
  }

  return {
    ...state,
    data,
  };
}

function clearRelatedData(state, action) {
  let { paginatedResource, resourceType, id } = action;
  id = id || noId;
  if (has(state.data, [paginatedResource, resourceType, id])) {
    let data = { ...state.data };
    delete data[paginatedResource][resourceType][id];
    return {
      ...state,
      data,
    };
  } else {
    return state;
  }
}

function updateRelatedData(state, action) {
  const {
    type,
    requestInfo: { resourceType, id, paginatedResource, resourceId },
    result,
  } = action;
  // const paginatedResource = FILES_PAGINATED;
  switch (type) {
    case FILE_REINGESTION_SUCCESS:
      {
        let { status, output } = result;
        if (id && status === 'ok' && has(state.data, [paginatedResource, resourceType, id])) {
          let data = { ...state.data };
          let thisResourceData = data[paginatedResource][resourceType][id];

          const outputFilesUpdated = map(output, (o) => o.fullPath);
          thisResourceData.metrics.data = map(thisResourceData.metrics.data, (d) => {
            if (includes(outputFilesUpdated, d.name)) {
              return {
                ...d,
                ingestionStatus: Constants.IngestionStatus.QUEUED_REINGEST,
              };
            } else {
              return d;
            }
          });

          data[paginatedResource][resourceType][id] = thisResourceData;
          return { ...state, data };
        }
      }
      break;

    case UPDATE_RESOURCE_NOTIFICATION_AS_READ_SUCCESS:
      if (resourceId && has(state.data, [paginatedResource, resourceType, resourceId])) {
        let data = { ...state.data };
        let thisResourceData = data[paginatedResource][resourceType][resourceId];
        thisResourceData.data.items[id] = {
          ...thisResourceData.data.items[id],
          read_at: Date.now(),
        };
        data[paginatedResource][resourceType][resourceId] = thisResourceData;
        return { ...state, data };
      }
      break;

    default:
      break;
  }

  return state;
}

function removeRelatedDataItem(state, action) {
  const {
    type,
    requestInfo: { resourceType, id, paginatedResource, resourceId },
  } = action;

  switch (type) {
    case DELETE_RESOURCE_NOTIFICATION_SUCCESS:
      if (resourceId && has(state.data, [paginatedResource, resourceType, resourceId])) {
        let data = { ...state.data };
        let thisResourceData = data[paginatedResource][resourceType][resourceId];

        thisResourceData.data.ids = pull(thisResourceData.data.ids, id);
        delete thisResourceData.data.items[id];

        data[paginatedResource][resourceType][resourceId] = thisResourceData;
        return { ...state, data };
      }
      break;
    default:
  }
  return state;
}

export function getPaginationMetaFromResponseHeaders(rspHeaders = null, requestInfo = null) {
  let totalItemsCount = 1,
    currentPage = 1,
    perPageCount = 1,
    numPagesCount = 1;

  if (rspHeaders) {
    totalItemsCount = Number(
      has(rspHeaders, 'X-Total-Count') ? rspHeaders['X-Total-Count'] : totalItemsCount,
    );
    currentPage = Number(
      has(rspHeaders, 'X-Current-Page') ? rspHeaders['X-Current-Page'] : currentPage,
    );
    perPageCount = Number(has(requestInfo, 'per_page') ? requestInfo.per_page : perPageCount);
    numPagesCount = Number(
      has(rspHeaders, 'X-Total-Page-Count')
        ? rspHeaders['X-Total-Page-Count']
        : ceil(totalItemsCount / perPageCount),
    );

    numPagesCount = Math.max(1, numPagesCount);
  }

  return {
    totalItemsCount,
    currentPage,
    perPageCount,
    numPagesCount,
    sortBy: requestInfo?.sort_by,
    sortOrder: requestInfo?.sort_order,
  };
}
